import faqSchemas from "./faq-schemas.json";

const normalizePath = (url) => {
    if (!url || typeof url !== "string") return null;

    try {
        const parsedUrl = new URL(url, process.env.GATSBY_SITE_URL);
        return parsedUrl.pathname.replace(/\/$/, "") || "/";
    } catch {
        return url.replace(/\/$/, "") || "/";
    }
};

const faqSchemasByPath = Object.entries(faqSchemas).reduce(
    (schemasByPath, [path, schema]) => {
        const normalizedPath = normalizePath(path);

        if (normalizedPath && schema) {
            schemasByPath[normalizedPath] = schema;
        }

        return schemasByPath;
    },
    {},
);

const getFaqSchemaForPost = (post, pathname) => {
    const pagePath = normalizePath(pathname);
    const canonicalPath = normalizePath(post?.seo?.canonical);
    const uriPath = normalizePath(post?.uri);

    return (
        faqSchemasByPath[pagePath] ||
        faqSchemasByPath[canonicalPath] ||
        faqSchemasByPath[uriPath] ||
        null
    );
};

export { getFaqSchemaForPost };
